import { useLocation, useParams } from "react-router-dom";
import ChallengeChainWizard from "../../components/partials/challenge/wizard/ChallengeChainWizard";
import type { GoldenChallengeChain } from "../../services/webServices/challenge/types";

export default function ChallengeChainForm() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const chain = (location.state as { chain?: GoldenChallengeChain } | null)
    ?.chain;

  return <ChallengeChainWizard challengeId={id} initialChain={chain} />;
}
